export const ALLOWED_ATTACHMENT_ACCEPT = [
  'image/*',
  'video/mp4',
  '.mp4',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
  '.csv',
].join(',')

const allowedExtensions = new Set([
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  'mp4',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'csv',
])

export function isAllowedAttachmentFile(file: File): boolean {
  const extension = file.name.split('.').pop()?.toLowerCase() || ''
  return allowedExtensions.has(extension)
}

export function getAllowedAttachmentMessage(): string {
  return 'Only images, MP4 video, PDF, Word, Excel, and CSV files are allowed.'
}
